// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-dialog-input--messages[data-v-95653cbe]{color:red;min-height:14px;margin-bottom:3px;font-size:12px}", ""]);
// Exports
module.exports = exports;
